var map = {
	"./cn/author.json": [
		6876,
		4467
	],
	"./cn/category.json": [
		6176,
		6176
	],
	"./cn/footer.json": [
		666,
		666
	],
	"./cn/header.json": [
		6183,
		6183
	],
	"./cn/index.json": [
		1970,
		1970
	],
	"./cn/modal.json": [
		7000,
		7000
	],
	"./cn/news.json": [
		4093,
		4093
	],
	"./cn/search.json": [
		5353,
		5353
	],
	"./tw/author.json": [
		5625,
		5625
	],
	"./tw/category.json": [
		1458,
		1458
	],
	"./tw/footer.json": [
		4869,
		4869
	],
	"./tw/header.json": [
		5185,
		5185
	],
	"./tw/index.json": [
		1136,
		1136
	],
	"./tw/modal.json": [
		4267,
		4267
	],
	"./tw/news.json": [
		2110,
		8109
	],
	"./tw/search.json": [
		7480,
		7480
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 492;
module.exports = webpackAsyncContext;